<div class="faq-header">
    <h2>F.A.Q</h2>
    <p class="subtitle">{{getString('faqSubtitle')}}</p>
</div>
<div class="faq-container">
    <ng-container *ngFor="let faq of faqs">
        <div class="faq-question" (click)="toggleFAQ(faq)">
            {{ faq.question }}
            <span class="faq-toggle-icon" [class.expanded]="faq.expanded">&#9660;</span>
        </div>
        <div class="faq-answer" [class.expanded]="faq.expanded" [innerHTML]="faq.answer"></div>
    </ng-container>
</div>